import React, { useEffect, useState } from "react";
import { Table, Tag, Modal, Select, Input } from "antd";
import { AiFillDelete } from "react-icons/ai";
import { BiEdit } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import {
    deleteDMC,
    getDMCs,
    resetState,
    updateDMCStatus,
} from "../features/dmc/dmcSlice";
import CustomModal from "../components/CustomModal";

const { Option } = Select;
const { TextArea } = Input;

const DMCList = () => {
    const dispatch = useDispatch();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [statusModalOpen, setStatusModalOpen] = useState(false);

    const [selectedId, setSelectedId] = useState(null);
    const [newStatus, setNewStatus] = useState("");
    const [rejectionReason, setRejectionReason] = useState("");

    useEffect(() => {
        dispatch(resetState());
        dispatch(getDMCs());
    }, [dispatch]);

    const dmcList = useSelector((state) => state.dmc.DMCs) || [];

    // ---------------- Delete ----------------
    const openDeleteModal = (id) => {
        setSelectedId(id);
        setDeleteModalOpen(true);
    };

    const handleDelete = () => {
        dispatch(deleteDMC(selectedId));
        setDeleteModalOpen(false);
        setTimeout(() => dispatch(getDMCs()), 300);
    };

    // ---------------- Status Update ----------------
    const openStatusModal = (item) => {
        setSelectedId(item._id);
        setNewStatus(item.status);
        setRejectionReason(item.rejectionReason || "");
        setStatusModalOpen(true);
    };

    const handleStatusUpdate = () => {
        dispatch(
            updateDMCStatus({
                id: selectedId,
                status: newStatus,
                rejectionReason:
                    newStatus === "REJECTED" ? rejectionReason : "",
            })
        );
        setStatusModalOpen(false);
        setTimeout(() => dispatch(getDMCs()), 300);
    };

    // ---------------- Table ----------------
    const columns = [
        {
            title: "S.No",
            dataIndex: "key",
            width: 70,
        },
        {
            title: "Contact Name",
            dataIndex: "name",
        },
        {
            title: "Phone",
            dataIndex: "phone",
        },
        {
            title: "Email",
            dataIndex: "email",
        },
        {
            title: "Company",
            dataIndex: "company",
        },
        {
            title: "Website",
            dataIndex: "website",
            // render: (text) =>
            //     text ? (
            //         <a href={text} target="_blank" rel="noreferrer">
            //             {text}
            //         </a>
            //     ) : (
            //         "—"
            //     ),
        },
        {
            title: "Country",
            dataIndex: "country",
        },
        {
            title: "State",
            dataIndex: "state",
        },
        {
            title: "Destinations",
            dataIndex: "destinations",
        },
        {
            title: "Services",
            dataIndex: "services",
        },
        {
            title: "Document",
            dataIndex: "documents",
        },
        // {
        //     title: "Travel License",
        //     dataIndex: "travelLicense",
        // },
        // {
        //     title: "Tax Certificate",
        //     dataIndex: "taxCert",
        // },
        {
            title: "Status",
            dataIndex: "status",
        },
        {
            title: "Action",
            dataIndex: "action",
        },
    ];

    const dataSource = dmcList.map((item, index) => ({
        key: index + 1,
        name: item.contactName,
        phone: item.phone,
        email: item.email,
        company: item.companyName,
        website: item.website,
        country: item.country,
        state: item.state,
        destinations: item.destinations,
        services: item.services?.join(", ") || "—",

        documents: item.documents ? (
            Object.entries(item.documents).map(([name, url], index) => (
                <div key={index}>

                    <a href={url} target="_blank" rel="noreferrer">
                        <p>{name}</p>
                    </a>
                </div>
            ))
        ) : (
            "No Document"
        ),

        status:
            item.status === "APPROVED" ? (
                <Tag color="green">APPROVED</Tag>
            ) : item.status === "PENDING" ? (
                <Tag color="orange">PENDING</Tag>
            ) : item.status === "UNDER_REVIEW" ? (
                <Tag color="blue">UNDER REVIEW</Tag>
            ) : item.status === "REJECTED" ? (
                <Tag color="red">REJECTED</Tag>
            ) : (
                <Tag>{item.status}</Tag>
            ),

        action: (
            <div className="d-flex gap-3">
                {/* Update Status */}
                <button
                    className="bg-transparent border-0 text-primary fs-4"
                    onClick={() => openStatusModal(item)}
                    title="Update Status"
                >
                    <BiEdit />
                </button>

                {/* Delete */}
                <button
                    className="bg-transparent border-0 text-danger fs-4"
                    onClick={() => openDeleteModal(item._id)}
                    title="Delete"
                >
                    <AiFillDelete />
                </button>
            </div>
        ),
    }));

    return (
        <div>
            <h3 className="mb-4 title">DMC Supplier List</h3>

            <Table
                columns={columns}
                dataSource={dataSource}
                bordered
                pagination={{ pageSize: 10 }}
            />

            {/* Delete Modal */}
            <CustomModal
                open={deleteModalOpen}
                hideModal={() => setDeleteModalOpen(false)}
                performAction={handleDelete}
                title="Are you sure you want to delete this DMC?"
            />

            {/* Status Update Modal */}
            <Modal
                title="Update Supplier Status"
                open={statusModalOpen}
                onOk={handleStatusUpdate}
                onCancel={() => setStatusModalOpen(false)}
                okText="Update"
            >
                <div className="mb-3">
                    <label>Status</label>
                    <Select
                        value={newStatus}
                        onChange={setNewStatus}
                        style={{ width: "100%" }}
                    >
                        <Option value="PENDING">PENDING</Option>
                        <Option value="UNDER_REVIEW">UNDER REVIEW</Option>
                        <Option value="APPROVED">APPROVED</Option>
                        <Option value="REJECTED">REJECTED</Option>
                        <Option value="SUSPENDED">SUSPENDED</Option>
                    </Select>
                </div>

                {newStatus === "REJECTED" && (
                    <div>
                        <label>Rejection Reason</label>
                        <TextArea
                            rows={4}
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            placeholder="Enter rejection reason"
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default DMCList;
